import { Button, Checkbox, Col, Divider, Form, Image, Input, Popconfirm, Row, Select, Space, Spin, Table, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import WebLinks from '../../api/WebLinks';
import APIUtils from '../../api/APIUtils';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';

const{Column}=Table;
const { Option } = Select;
const { Search } = Input;

const fetchAvailableSuppliers = async (
	buyerID,
	config,
	setLoading,
	setSuppliers,
	setTotal
) => {
	setLoading(true);
	try {
		const { pageNumber, pageSize, country, search, sortDesc } = config;
		const url = `${WebLinks.GetMultiSuppliersAdmin}?buyerId=${encodeURIComponent(buyerID)}&allowedCountryCode=${encodeURIComponent(country || '')}&search=${encodeURIComponent(search)}&limit=${pageSize}&pageNo=${pageNumber}&sortDesc=${sortDesc}`;
		const response = await APIUtils.apiCall('GET', url);
		if (response.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else if (response.resultObj?.statusCode === '2000') {
			setSuppliers(response.resultObj.data || []);
			setTotal(response.resultObj?.getCount || 0);
		} else {
			message.error(response.resultObj?.message || constants.ERROR_MESSAGE);
		}
	} finally {
		setLoading(false);
	}
};

const fetchCountryList = async (setLoading, setCountries) => {
	setLoading(true);
	try {
		const response = await APIUtils.apiCall('GET', WebLinks.GetCountryList);
		if (!response.isCatch) {
			setCountries(response.resultObj?.data || []);
		} else {
			message.error(response.resultObj?.message || constants.ERROR_MESSAGE);
		}
	} finally {
		setLoading(false);
	}
};

const MultiSupplierAdmin = (props) => {
	//Variable Declaration
	const commonContext=useContext(CommonContext);
  const buyerID = commonContext.common.buyerId;
	const isMasterBuyer = sessionStorage.getItem('isMasterBuyer');
	const [priorityList,setPriorityList]=useState([]);
	const [suppliers,setSuppliers]=useState([]);
	const [pageNumber,setPageNumber]=useState(1);
  const [sortDesc,setSortDesc]=useState(true);
  const [total,setTotal]=useState(0);
  const [loading,setloading]=useState(false);
  const [form] = Form.useForm();
  const [supplierList,setsupplierList]=useState([]);
	const [multiBudget,setMultiBudget]=useState('0');
	const [availableSuppliers,setAvailableSuppliers]=useState([]);
	const [availableSuppliersTotal,setAvailableSuppliersTotal]=useState(0);
	const [availableSuppliersLoading,setAvailableSuppliersLoading]=useState(false);
	const [countryList,setCountryList]=useState([]);
	const [countryLoader,setCountryLoader]=useState(false);
	const [availableSuppliersRefresh,setAvailableSuppliersRefresh]=useState(0);
	const [availableSuppliersConfig,setAvailableSuppliersConfig]=useState({
		pageNumber:1,
		sortDesc:false,
		pageSize:constants.supplierPageSize,
		country:'',
		search:''
	});

	//On load
	useEffect(()=>{
		fetchData();
		trackPageAccess(buyerID,window.location.href)
	},[]);
	useEffect(()=>{
		fetchAvailableSuppliers(
			buyerID,
			availableSuppliersConfig,
			setAvailableSuppliersLoading,
			setAvailableSuppliers,
			setAvailableSuppliersTotal
		);
	},[availableSuppliersConfig, buyerID, availableSuppliersRefresh]);
	useEffect(()=>{
		fetchCountryList(setCountryLoader, setCountryList);
	},[]);

	//Functions 
	//Function to fetch multi supplier admin data
	const fetchData = async () =>{
		setloading(true);
		const supplirAdmins = await APIUtils.apiCall("GET",WebLinks.GetMultiSupplierAdmin+buyerID,null);
		if (supplirAdmins.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if(supplirAdmins.resultObj?.statusCode==="2000") {
				setPriorityList(supplirAdmins.resultObj.data)
				setTotal(supplirAdmins.resultObj.data?.getCount || 0);
				setSuppliers(supplirAdmins?.resultObj?.supplierList);
			} else {
				message.error(supplirAdmins.resultObj?.message || constants.ERROR_MESSAGE)
			}
		}
		setloading(false);
	}

	const handleCountrySelect = (value) => {
		setAvailableSuppliersConfig((previous) => ({
			...previous,
			country: value === 'showall' ? '' : value || '',
			pageNumber: 1
		}));
	};

	const handleSupplierSearch = (value) => {
		setAvailableSuppliersConfig((previous) => ({
			...previous,
			search: value,
			pageNumber: 1
		}));
	};

	const handleAddSupplier = async (supplier) => {
		const url = `${WebLinks.AddMultiSupplier}?buyerId=${encodeURIComponent(buyerID)}&supplierId=${encodeURIComponent(supplier.supplierId)}`;
		const response = await APIUtils.apiCall('POST', url);
		if (!response.isCatch && response.resultObj?.statusCode === '2000') {
			message.success(response.resultObj.message);
		} else {
			message.error(response.resultObj?.message || constants.ERROR_MESSAGE);
		}
		fetchData();
		setAvailableSuppliersRefresh((previous) => previous + 1);
	};

	// Table start
	const onChangeTable = (pagination, filters, sorter, extra)=>{
		setSortDesc(sorter.order==="ascend"?false:true);
		fetchData();
	  }
	// Table end
	
  //On supplier selected checkbox
  const onSupplierSelected=(e,supplierId)=>{
    let tempSupplierlist=supplierList;
		let tempIndex=tempSupplierlist.findIndex((item)=>item.supplierId===supplierId);
    if(e.target.checked){
      tempSupplierlist.push(supplierId);
    }else{
      tempSupplierlist=supplierList.filter(item => item!=supplierId);
    }
    setsupplierList(tempSupplierlist);
  }

	//Update selected suppliers
	const updateSelectedSuppliers=async(buyerId=null,supplierId=null,budgetvalue,reload=false,noneValue=false)=>{
		setloading(true);
		if(!supplierId || !supplierId.length>0){
			message.error("Please select suppliers to update.");
		}else{
		let payload=null;
		payload={
			buyerId: buyerId?.toString(),
			supplierId: supplierId.toString(),
			budget: budgetvalue,
			none:noneValue,
		}
		if(buyerId===null){
			payload.LoggedInBuyerId=Cookies.get(constants.COOKIE_LOGGED_BUYER_ID);
			payload.selectedBuyerId= buyerID;
		}
		const updateSupplierAdmins = await APIUtils.apiCall("PUT",WebLinks.UpdateMultiSupplierAdmin,JSON.stringify(payload));
		if (updateSupplierAdmins.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if(updateSupplierAdmins.resultObj?.statusCode==="2000") {
				message.success(updateSupplierAdmins.resultObj?.message)
			} else {
				message.error(updateSupplierAdmins.resultObj?.message | constants.ERROR_MESSAGE)
			}
		}
		}
		setloading(false);
		if(reload){
		setSuppliers([]);
		fetchData();
		}
	};

	const availableSupplierColumns = [
		{
			dataIndex: "supplierName",
			key: "supplierName",
			render: (_, supplier) => supplier.logoURL && supplier.logoURL !== ''
				? <Image src={supplier.logoURL} preview={false} width={100} />
				: supplier.supplierDisplayName
		},
		{
			dataIndex: "supplierDisplayName",
			key: "supplierDisplayName",
			title: "Supplier Name"
		},
		{
			dataIndex: "allowedCountryCodes",
			key: "allowedCountryCodes",
			title: "Countries"
		},
		{
			dataIndex: "type",
			key: "type",
			title: "Type"
		},
		{
			key: "addSupplier",
			title: "",
			render: (_, supplier) => (
				<Popconfirm
					title="Add Supplier"
					description="Are you sure to add this supplier?"
					onConfirm={() => handleAddSupplier(supplier)}
					okText="Yes"
					cancelText="No"
				>
					<Button>Add Supplier</Button>
				</Popconfirm>
			)
		}
	];

	return (
    <>
			<Spin spinning={false}>
				<div>
          <div className='uppercase font-bold text-xl'>Multi Supplier Admin</div>
          <Divider className='mt-2 mb-3' />
					<div className='flex justify-between items-center mb-3'>
						<Space wrap>
							<Form form={form} >
							<Row gutter={[12, 12]}>
								<Col>
								<Space wrap>
								<label>Update all selected jobs to:</label>
								<Form.Item name="supplierList" className='mb-0'>
                  <Space.Compact>
									<Select
										className='!w-72'
										defaultValue={'0'}
										allowClear={false}
										filterOption={(input, option) =>
												option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
												option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										onChange={(e) => setMultiBudget(e)}
										>
											<Option key='Distribute' value='0'>Distribute</Option>
                      <Option key='Budget' value='1'>Budget</Option>
											<Option key='none' value='2'>None</Option>												
									</Select>
                  <Button type="primary" onClick={()=>updateSelectedSuppliers(null,supplierList,multiBudget==="1"?true:false,true,multiBudget==="2"?true:false)}>Update</Button>
                  </Space.Compact>
								</Form.Item>
								</Space>
                </Col>
								<Col></Col>
								</Row>
							</Form>
						</Space>
					</div>
          <div className='overflow-x-auto'>
            <Table dataSource={priorityList} 
              loading={loading}
              sortDirections={['ascend', 'descend','ascend']}
              // pagination={{
              //   onChange: (page) => {
              //     setPageNumber(page);
              //   },
              //   defaultPageSize: constants.pageSize,
              //   pageSizeOptions: ["25", "50", "100"],
              //   total:total,
              // }}
              pagination={false}
              // scroll={{ x: 1000, y: 590 }} 
              // onChange={onChangeTable}
							>
              <Column title="Cost Center"  dataIndex="buyerName" key="buyerName" sorter={(a, b) =>( a.buyerName - b.buyerName)} fixed={window.innerWidth > 1024 ? true : false} />
              {suppliers?.map((item,index)=>{ 
                return(<Column title={item.logoURL && item.logoURL!==""?<><Image src={item.logoURL} preview={false} width={70}/><br/><Checkbox onChange={(e)=>onSupplierSelected(e,item.supplierId)}/></>:item.supplierName} dataIndex={item.supplierName} key={item.supplierName} align='center'
                render={(_,data,pIndex) => {
                  let supplierIndex = data.costCenterSupplierDetails?.findIndex((dataItem)=>dataItem.supplierName === item.supplierName);
                  let supplierItem;
									if(supplierIndex>=0){
									 supplierItem = data.costCenterSupplierDetails[supplierIndex]
									}
                  return(
                    <>
										{/* <>{supplierItem?.supplierId},{supplierIndex}</> */}
										{/* {supplierItem?.supplierId? */}
											{isMasterBuyer && isMasterBuyer !== "null" && !supplierItem?.supplierId ? 'None' :
											<Select
												className='!w-30'
												placeholder={constants.supplierName}
												defaultValue={supplierItem?.supplierId ? supplierItem?.budget ? "1" : "0" : "2"}
												onChange={(e) => updateSelectedSuppliers(data?.buyerId, [supplierItem?.supplierId ? supplierItem.supplierId : item.supplierId], e === "1" ? true : false, false, e === "2" ? true : false)}
											>
												<Option key='Distribute' value='0'>Distribute</Option>
												<Option key='Budget' value='1'>Budget</Option>
												<Option key='none' value='2'>None</Option>
											</Select>
											}
										{/* :<></>} */}
                    </>
                  )
                  }}/>)
                })}
            </Table>
          </div>
					<div className='flex flex-wrap justify-between items-end gap-3 mt-6 mb-3'>
						<div className='uppercase font-bold text-xl'>Add Supplier</div>
						<Space wrap>
							<Select
								onChange={handleCountrySelect}
								allowClear
								showSearch
								loading={countryLoader}
								placeholder="Select Country"
								className="w-60"
								filterOption={(input, option) =>
									(option?.children ?? '').toLowerCase().includes(input.toLowerCase())
								}
							>
								<Option key="showall" value="showall">Show All</Option>
								<Option key="global" value="global">Global</Option>
								{countryList.map((item) => (
									<Option key={item.countryCode} value={item.countryCode}>{item.country}</Option>
								))}
							</Select>
							<Search
								placeholder="Search"
								allowClear
								enterButton
								className="w-60"
								onSearch={handleSupplierSearch}
							/>
						</Space>
					</div>
					<div className='overflow-x-auto'>
						<Table
							dataSource={availableSuppliers}
							loading={availableSuppliersLoading}
							rowKey="supplierId"
							pagination={{
								current: availableSuppliersConfig.pageNumber,
								pageSize: availableSuppliersConfig.pageSize,
								pageSizeOptions: ['250', '500', '1000'],
								showSizeChanger: true,
								total: availableSuppliersTotal
							}}
							columns={availableSupplierColumns}
							onChange={(pagination) => setAvailableSuppliersConfig((previous) => ({
								...previous,
								pageNumber: pagination.current,
								pageSize: pagination.pageSize
							}))}
						/>
					</div>
				</div>
			</Spin>
		</>
	);
};

export default MultiSupplierAdmin;